import { render } from "./AdminCourseQuestions.vue?vue&type=template&id=ed0f93f8"
import script from "./AdminCourseQuestions.vue?vue&type=script&lang=js"
export * from "./AdminCourseQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__